import { gql } from "@apollo/client";

export const LOCATION_FRAGMENT = gql`
    fragment CoordinatePointType on CoordinatePointType {
        xCoordinate
        yCoordinate
    }
`;
